import { captureAppException } from './sentry';

/**
 * Redux / servis katmanında API hatalarını Sentry’ye iletir.
 *
 * @param {unknown} error — Yakalanan hata
 * @param {object} [meta]
 * @param {string} [meta.endpoint] — İstek URL veya path
 * @param {string} [meta.method] — HTTP metodu
 * @param {number|string} [meta.status] — HTTP durum kodu
 * @param {string} [meta.section] — `tags.section` (ör. callcenter, auth)
 * @param {string} [meta.action] — `tags.action`
 * @param {Record<string, unknown>} [meta.extra] — Ek alanlar
 */
export function captureApiError(error, meta = {}) {
  const { endpoint, method, status, section = 'general', action = 'api_error', extra = {} } = meta;
  captureAppException(error instanceof Error ? error : new Error(String(error)), {
    tags: { section, action },
    extra: {
      ...extra,
      endpoint: endpoint ?? undefined,
      method: method ?? undefined,
      status: status ?? undefined,
    },
  });
}

/**
 * Async thunk / API fonksiyonlarını try/catch ile sarar; hatayı Sentry’ye gönderip yeniden fırlatır.
 *
 * @template T
 * @param {() => Promise<T>} fn
 * @param {object} [meta] — {@link captureApiError} ile aynı meta şekli
 * @returns {Promise<T>}
 */
export async function withApiErrorCapture(fn, meta) {
  try {
    return await fn();
  } catch (error) {
    captureApiError(error, meta);
    throw error;
  }
}
